import React from 'react';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

import Tr from '../../../../components/common-table/components/Tr';
import Td from '../../../../components/common-table/components/Td';
import PasswordCell from './PasswordCell';
import BooleanCell from './BooleanCell';
import EditableCell from './EditableCell';
import { changeRequestsAmount } from '../../../../redux/user-management/userManagementActions';

import scss from './DemoUsersTable.module.scss';

function DemoUsersTableItem({ user, rowRank }) {
  const dispatch = useDispatch();
  const { email, companyName, userName, password, createdOn, requestedFullAccess, requestsLeft } = user;

  const handleChangeRequestsLeft = async (value) => {
    const numberOfRequests = parseInt(value);

    if (isNaN(numberOfRequests)) {
      return;
    }

    await dispatch(changeRequestsAmount({ id: user.id, requests: numberOfRequests }));
  };

  return (
    <Tr>
      <Td extraClasses={scss.cellId}>{rowRank}</Td>
      <Td extraClasses={scss.cellLeft}>{userName}</Td>
      <Td extraClasses={scss.cellLeft}>{companyName}</Td>
      <Td extraClasses={scss.cellLeft}>{email}</Td>
      <Td extraClasses={scss.cellLeft}>
        <EditableCell
          value={requestsLeft.toString()}
          onSave={handleChangeRequestsLeft}
          validationSchema={validationSchema}>
          {requestsLeft}
        </EditableCell>
      </Td>
      <Td extraClasses={scss.cellLeft}>
        <BooleanCell value={requestedFullAccess} />
      </Td>
      <Td extraClasses={scss.cellLeft}>
        <PasswordCell password={password} />
      </Td>
      <Td extraClasses={scss.cellLeft}>{createdOn}</Td>
    </Tr>
  );
}

export default DemoUsersTableItem;

const validationSchema = yup.object().shape({
  value: yup.number('invalidRequestsAmount').required('required').integer('invalidRequestsAmount'),
});
